import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { APIBASE } from '../config.js';
import THEME from '../theme.js';
import DemoEmbed, { demoEmbeds } from './EmbedsFrameDemo.js';
const EmbedsFrame = (props) => {
    const tenantId = useSelector(selectTenantId);
    const authToken = useSelector(selectAuthToken);
    const lang = useSelector((s) => s.lang);
    const { id } = props;
    const [page, setPage] = useState('');
    const [error, setError] = useState(false);
    const url = `${APIBASE}/v1/${tenantId}/embeds/${id}?context=${encodeURIComponent(JSON.stringify(props.context || {}))}`;
    const demoEmbed = demoEmbeds[props.id];
    const handler = (req) => {
        if (req.readyState === req.DONE) {
            if (req.target.status === 200) {
                const dataURL = window.URL.createObjectURL(req.target.response);
                setPage(dataURL);
            }
            else {
                setError(true);
            }
        }
    };
    useEffect(() => {
        if (demoEmbed) {
            return;
        }
        if (!page) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onreadystatechange = handler;
            xhr.responseType = 'blob';
            xhr.setRequestHeader('Authorization', 'Bearer ' + authToken);
            xhr.send();
        }
    }, []);
    const style = {
        height: props.height
            ? `${props.height}px`
            : `calc(100vh - ${THEME.NAV_TOP_HEIGHT}px)`,
        width: '100%',
    };
    return (React.createElement("div", null,
        error && (React.createElement("div", { style: {
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement("h3", { style: { opacity: 0.4 } }, lang.embeds.couldNotLoad))),
        demoEmbed ? (React.createElement(DemoEmbed, { demoEmbed: demoEmbed })) : (page && (React.createElement("iframe", { style: {
                ...style,
                border: 'none',
            }, src: page })))));
};
export default EmbedsFrame;
//# sourceMappingURL=EmbedsFrame.js.map